import DealStageType from "@mapmycustomers/shared/enum/DealStageType";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

export const getWonStageIds = (
  funnelStages: Record<number, Stage[]>,
  selectedFunnelIds: number[] | undefined
): Stage["id"][] => {
  const funnelIds =
    selectedFunnelIds && selectedFunnelIds.length
      ? selectedFunnelIds
      : Object.keys(funnelStages).map((id) => Number(id));

  return funnelIds
    .flatMap((funnelId) => funnelStages[funnelId] ?? [])
    .filter((stage) => stage.type === DealStageType.WON)
    .map((stage) => stage.id);
};

export default getWonStageIds;
